var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cuore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OS_Head",
    transform: "translate(-662.000000, -38.000000)",
    fill: "#D0021B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.013717,42.9931413 C672.013717,41.6031036 671.524468,40.4234156 670.545953,39.4540466 C669.567438,38.4846776 668.383179,38 666.993141,38 C665.603104,38 664.423416,38.4846776 663.454047,39.4540466 C662.484677,40.4234156 662,41.6031036 662,42.9931413 C662,45.0050412 662.667574,46.6785494 664.002743,48.0137174 L672.013717,53.994513 C676.128964,51.2144352 678.790117,49.2208573 679.997257,48.0137174 C681.332425,46.6785494 682,45.0050412 682,42.9931413 C682,41.6031036 681.515322,40.4234156 680.545953,39.4540466 C679.576584,38.4846776 678.396896,38 677.006859,38 C675.616821,38 674.437133,38.4846776 673.467764,39.4540466 C672.498395,40.4234156 672.013717,41.6031036 672.013717,42.9931413 Z",
    id: "cuore"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d842f34fb7e770a49fcc2d78d056f128.svg";
export { ForwardRef as ReactComponent };